import axios from 'axios';

export function getVesselClaims() {
    return axios({
        method: 'get',
        url: '/api/v1/users/claim/vessel',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function acceptUserClaimsToVessel(userId, vesselId) {
    return axios({
        method: 'post',
        url: '/api/v1/users/claim/vessel/accept',
        withCredentials: true,
        data: {
            user: userId,
            vessel: vesselId,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function rejectUserClaimsToVessel(userId, vesselId) {
    return axios({
        method: 'post',
        url: '/api/v1/users/claim/vessel/reject',
        withCredentials: true,
        data: {
            user: userId,
            vessel: vesselId,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/vessels/claims.js